import { render } from "./equipment-bundles.vue?vue&type=template&id=115ecbdf&scoped=true"
import script from "./equipment-bundles.vue?vue&type=script&lang=js"
export * from "./equipment-bundles.vue?vue&type=script&lang=js"

import "./equipment-bundles.vue?vue&type=style&index=0&id=115ecbdf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115ecbdf"]])

export default __exports__